import React, { FC, ReactNode, memo } from 'react';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      marginLeft: 15,
      alignItems: 'center',
      display: 'flex',
      flexDirection: 'row'
    },
    textContainer: {
      display: 'flex',
      backgroundColor: '#0099CC',
      width: '50%',
      minHeight: 60,
      alignItems: 'center'
    },
    textLine: {
      marginLeft: 15,
      color: '#FFFFFF',
      fontSize: 14,
      height: '100%'
    },
    multiTextContainer: {
      display: 'flex',
      backgroundColor: '#0099CC',
      width: '50%',
      minHeight: 121,
      alignItems: 'center'
    },
    multiTextLine: {
      marginLeft: 15,
      color: '#FFFFFF',
      fontSize: 14
    }
  })
);

type Props = {
  children: ReactNode;
  text: string;
  multiLine?: boolean;
  span?: boolean;
  help?: ReactNode;
};

const InputElementContainer: FC<Props> = props => {
  const { children, text, multiLine = false, span = false, help } = props;
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <div
        className={
          multiLine ? classes.multiTextContainer : classes.textContainer
        }
      >
        <div className={multiLine ? classes.multiTextLine : classes.textLine}>
          {text}
          {span && <span>*</span>}
          {help ?? help}
        </div>
      </div>
      {children}
    </div>
  );
};

export default memo(InputElementContainer);
